import image1 from '../../assets/images/list/1.jpg';
import image2 from '../../assets/images/list/2.jpg';
import image3 from '../../assets/images/list/3.jpg';
import image4 from '../../assets/images/list/4.jpg';
import image5 from '../../assets/images/list/5.jpg';
import image6 from '../../assets/images/list/6.jpg';
import image7 from '../../assets/images/list/7.jpg';
import image8 from '../../assets/images/list/8.jpg';
import image9 from '../../assets/images/list/9.jpg';
import image10 from '../../assets/images/list/10.jpg';
import image11 from '../../assets/images/list/11.jpg';
import image12 from '../../assets/images/list/12.jpg';
import image13 from '../../assets/images/list/13.jpg';

const DataSliderBox = [
  {
    id: 1,
    src: image1,
	title:"Scholarship Facility",
	link:'/facility',
	icon:<span className="flaticon-envelope"></span>,
	description:"Every year aspiring school students eagerly seek opportunities to secure their educational dreams.",
    alt: "Secure Educational Dreams",
  },
  {
    id: 2,
    src: image2,
	title:"Transport",
	link:'/sports',
	icon:<span className="flaticon-smartphone"></span>,
	description:"Transport – The need for safe passage of each child to school and back home is of paramount importance to us. ",
    alt: "School Buses"
  },{
    id: 3,
    src: image3,
	title:"Books & Library",
	link:'/library',
	icon:<span className="flaticon-placeholder"></span>,
	description:"A school library is much more than a repository of books.",
    alt: "School Library"
  },{
    id: 4,
    src: image4,
	title:"Regular Classes",
	link:'/classrooms',
	icon:<span className="flaticon-placeholder"></span>,
	description:"A regular school facilitates regularity in the students as they have to attend classes regularly for attendance.",
    alt: "Smart Classes"
  },{
    id: 5,
    src: image5,
	title:"Educational Tours",
	link:'/tour',
	icon:<span className="flaticon-placeholder"></span>,
	description:"Educational trips involve group activities and require students to work together, which helps them develop teamwork skills and social skills. ",
    alt: "Tour and Excursions"
  },{
    id: 6,
    src: image6,
	title:"School Campus",
	link:'/campus',
	icon:<span className="flaticon-placeholder"></span>,
	description:"The Two-story school building, constructed with exotic stone masonry, boasts over fifty spacious classrooms, well-equipped science labs, an ultra-modern computer lab, an auditorium, an audio-visual room, and a comprehensive library.",
    alt: "Two-Story Building",
  },{
    id: 7,
    src: image7,
	title:"Addmissions",
	link:'/addmission',
	icon:<span className="flaticon-envelope"></span>,
	description:"At Our School, we emphasize both academic and extracurricular activities, ensuring a balanced, integrated approach to education. Our curriculum, based on RBSE syllabi, incorporates valuable elements from Indian and Western teaching systems.",
    alt: "Regular Addmissions",
  },
  {
    id: 8,
    src: image8,
	title:"Child Extra Activity",
	link:'/art&craft',
	icon:<span className="flaticon-smartphone"></span>,
	description:"Extra-curricular activities will help your child improve academically, become a good team player, and develop confidence. ",
    alt: "Child Extra Activity"
  },{
    id: 9,
    src: image9,
	title:"Fee Structure",
	link:'/fee',
	icon:<span className="flaticon-placeholder"></span>,
	description:"Parents are earnest about their child’s education in India. They start having high expectations from their children from the day they start schooling. They motivate them to get the best results in class from day one.",
    alt: "Fee Chart"
  },{
    id: 10,
    src: image10,
	title:"Latest Events",
	link:'/events',
	icon:<span className="flaticon-placeholder"></span>,
	description:"Have a look at all the events and gatherings at School.",
    alt: "Regular Classes"
  },{
    id: 11,
    src: image11,
	title:"Music& Dance",
	link:'/music&dance',
	icon:<span className="flaticon-placeholder"></span>,
	description:"Hosting a talent show is a great way to bring students, teachers, and parents together for a night of entertainment! The children will relish the opportunity to compete and cheer one another on, and the buzz generated by your talent show can open the door to being able to host similar events in the future.",
    alt: "Music& Dance"
  },{
    id: 12,
    src: image12,
	title:"Latest News",
	link:'/news',
	icon:<span className="flaticon-placeholder"></span>,
	description:"Check out for the latest news on school.",
    alt: "Latest News"
  },{
    id: 13,
    src: image13,
	title:"Gallery",
	link:'/photogallery',
	icon:<span className="flaticon-placeholder"></span>,
	description:"Our School Gallery exhibits student creativity and achievements, featuring artwork, photography, music, and projects that reflect our school's culture and values.",
    alt: "Gallery"
  }
];
export default DataSliderBox;